import BaseRoute from "../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../lib/itn-ui-kit/services/service-container";
import { defaultUrlQueryParams } from "../../../components/modules/FollowUps/dashboard-swimlanes/utils/strings";

import Template from "./template";

export default class DashboardIdRoute extends BaseRoute {
  @service("repositories/dashboard-lanes-repository") lanesRepository;
  @service("repositories/dashboard-lanes-actionable-item-repository") actionableRepository;

  path = "dashboard/:route_id";
  element = (<Template />);
  revalidateOnParams = ["route_id"];
  allowManualRevalidate = false;

  async loader({ params, request }) {
    const { route_id } = params;
    const url = new URL(request.url);
    const searchParams = Object.fromEntries(url.searchParams.entries());
    delete searchParams.rvDashboardId; // Internal param for revalidation only
    const mergedQuery = { ...defaultUrlQueryParams, ...searchParams };

    let lanes = [];
    try {
      const laneResults = await this.lanesRepository.query({ route: route_id });
      lanes = (laneResults ?? []).sort((a, b) => a.laneOrder - b.laneOrder);
    } catch (error) {
      console.error("Error loading lanes:", error);
      return error;
    }

    const actionItems = {};
    const actionItemsCounts = {};

    if (lanes.length) {
      const lanePayloads = await Promise.all(
        lanes.map(async (lane) => {
          try {
            const items = await this.actionableRepository.query(lane.id, mergedQuery);
            const total = await this.actionableRepository.getTotalCount(lane.id);
            return { laneId: lane.id, items, total };
          } catch (error) {
            console.error(`Error loading action items for lane ${lane.id}:`, error);
            return { laneId: lane.id, items: [], total: 0 };
          }
        })
      );

      for (const { laneId, items, total } of lanePayloads) {
        actionItems[laneId] = items;
        actionItemsCounts[laneId] = total;
      }
    }

    return {
      lanes,
      actionItems,
      actionItemsCounts,
    };
  }
}
